module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hans/5/1-0055407cf98bc7cf95918d60f3d32854.jpg";